import { Component, inject, signal, OnInit, OnDestroy } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialogContent,
  MatDialogModule,
  MatDialogRef,
  MatDialogTitle
} from "@angular/material/dialog";
import { CommonConfirmDialog } from "../common-confirm-dialog/common-confirm-dialog.model";
import { MatButtonModule } from "@angular/material/button";
import { TranslatePipe } from "@ngx-translate/core";
import { SessionTimeoutService } from "../../services/session-timeout-service";

@Component({
  selector: "app-session-dialog-component",
  imports: [MatDialogModule, MatDialogTitle, MatDialogContent, MatButtonModule, TranslatePipe],
  templateUrl: "./session-dialog-component.html",
  styleUrl: "./session-dialog-component.scss"
})
export class SessionDialogComponent implements OnInit, OnDestroy {
  public dialogRef = inject(MatDialogRef<SessionDialogComponent>);
  public data = inject<CommonConfirmDialog>(MAT_DIALOG_DATA);
  private sessionTimeoutService = inject(SessionTimeoutService);
  countNumber = signal(60);
  private intervalid!: ReturnType<typeof setInterval>;

  ngOnInit(): void {
    this.startCountdown();
  }

  ngOnDestroy(): void {
    clearInterval(this.intervalid);
  }

  private startCountdown(): void {
    this.intervalid = setInterval(() => {
      this.countNumber.update((updatedNumber) => updatedNumber - 1);
      if (this.countNumber() <= 0) {
        this.onLogout();
      }
    }, 1000);
  }

  onStay(): void {
    clearInterval(this.intervalid);
    this.dialogRef.close(true);
  }

  onLogout(): void {
    clearInterval(this.intervalid);
    this.sessionTimeoutService.stopWatching();
    this.dialogRef.close(false);
  }
}
